import React, { useEffect, useState } from "react"

import BubbleCard from "../ui-components/BubbleCard"
import AlertModalWithBody from "../ui-components/AlertModalWithBody"
import RecapSection from "./RecapSection"
import CancelledCard from "./CancelledCard"
import PendingPaymentCard from "./PendingPaymentCard"
import FailedPaymentCard from "./FailedPaymentCard"
import RatingCard from "./RatingCard"

import style from "./index.module.sass"
import GameCard from "./GameCard"
import { setAuthorizationToken } from "../apis/base";
import Actions from "./Actions";

// ----------------------------------------------------------------------------

// TODO: move to a const file
export const CASH_METHOD = "cash"
export const WALLET_METHOD = "wallet"

export const ORDER_STATUS = {
  PENDING_APPROVAL: "pending_approval",
  BRAND_NEW: "brand_new",
  PROCESSING: "processing",
  ACCEPTED: "accepted",
  COMPLETED: "completed",
  REJECTED: "rejected",
  PICKED_UP: "picked_up",
  CREATING: "creating",
  PENDING_PAYMENT: "pending_payment",
  PAYMENT_FAILED: "payment_failed",
}

export const PAYMENT_STATUS = {
  PENDING: "pending",
  PREAUTHORIZED: "preauthorized",
  PAID: "paid",
  FAILED: "failed",
  REFUNDED: "refunded",
  CANCELED: "canceled",
  UNKNOWN: "unknown",
  REQUIRES_AUTH: "requires_auth",
  EXPIRED: "expired",
}

export const MODE_TAKE_AWAY = "take_away"
const MODE_VENUE = "venue"

function OrderRecap(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { order = {}, gamesSettings = {}, userId, userToken } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  //const [showCovidModal, setShowCovidModal] = useState()

  // -------------------------------------
  // Effects
  // -------------------------------------

  useEffect(() => {
    setAuthorizationToken(userToken)
  }, [])

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function renderDeliveryHeader(dateStr) {
    let jsDate = new Date(dateStr)

    if (jsDate && jsDate > new Date()) {
      return renderHeader(
        I18n.t("pages.orders.show.order_request_received_next_days"),
        I18n.t("pages.orders.show.order_request_received_warning_next_days")
      )
    }

    return renderHeader(
      I18n.t("pages.orders.show.order_request_received"),
      I18n.t("pages.orders.show.order_request_received_warning")
    )
  }

  function renderHeader(title, desc, isHTMLDesc = false) {
    return (
      <div className={style.header}>
        <h1 className={style.headerTitle}>{title}</h1>
        {isHTMLDesc ? (
          <p
            className={style.headerThanks}
            dangerouslySetInnerHTML={{ __html: desc }}
          ></p>
        ) : (
          <p className={style.headerThanks}>{desc}</p>
        )}
      </div>
    )
  }

  function renderWarningCard(body, color) {
    return (
      <div className={style.bubbleContainer}>
        <BubbleCard color={color}>
          <div className={style.warningCardInner}>{body}</div>
        </BubbleCard>
      </div>
    )
  }

  /*function renderCovidAlert() {
    return (
      <div>
        <div
          className={style.covidLink}
          onClick={() => setShowCovidModal(true)}
        >
          <i className="fal fa-person-carry" />
          {` ${I18n.t("pages.orders.show.covid.link")}`}
        </div>
        <AlertModalWithBody
          show={showCovidModal}
          onHide={() => setShowCovidModal(false)}
          onConfirm={() => setShowCovidModal(false)}
          title={I18n.t("pages.orders.show.covid.title")}
          closeLabel={I18n.t("close")}
          isTiny={false}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: I18n.t("pages.orders.show.covid.body_html"),
            }}
          ></div>
        </AlertModalWithBody>
      </div>
    )
  }*/

  function renderGameCard() {
    if (gamesSettings?.hide_gamindo) return null

    return <GameCard userId={userId} orderId={order.id} userToken={userToken} />
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  let hide_rating = order.provider_name === "TLT"
  let alreadyRated = order.rating && order.rating.average
  let canBeRated = order.accepts_rating === true && !(order.mode === "take_away")
  const isRejectedByCustomer = order.reject_code === "rejected_by_customer"

  // -------------------------------------

  switch (order.status) {
    case ORDER_STATUS.PENDING_APPROVAL:
      return (
        <div className={style.container}>
          {renderHeader(
            I18n.t("pages.orders.show.order_pending_approval"),
            I18n.t("pages.orders.show.order_request_received_warning")
          )}
          {renderGameCard()}
          <RecapSection order={order} />
          <Actions order={order}/>
        </div>
      )
    case ORDER_STATUS.PICKED_UP:
      let description =
        order.mode === MODE_VENUE
          ? I18n.t("pages.orders.show.order_picked_up_venue_delivery_html")
          : I18n.t("pages.orders.show.order_picked_up_html", {
              name: order.racer?.first_name,
              phone: order.racer?.phone_number,
            })
      return (
        <div className={style.container}>
          {renderHeader(
            I18n.t("pages.orders.show.order_picked_up"),
            description,
            true
          )}
          {renderGameCard()}
          <RecapSection order={order} />
          <Actions order={order}/>
        </div>
      )
    case ORDER_STATUS.COMPLETED:
      return (
        <div className={style.container}>
          {renderHeader(
            I18n.t("pages.orders.show.order_delivered"),
            I18n.t("pages.orders.show.thanks")
          )}
          {(alreadyRated || (!alreadyRated && canBeRated)) && userToken && !hide_rating && (
            <RatingCard
              order={order}
              userToken={userToken}
              alreadyRated={alreadyRated}
              canBeRated={canBeRated}
            />
          )}
          <RecapSection order={order} />
          <Actions order={order}/>
        </div>
      )
    case ORDER_STATUS.REJECTED:
      if (
        order.payment?.status === PAYMENT_STATUS.EXPIRED ||
        order.payment?.status === PAYMENT_STATUS.FAILED
      ) {
        return (
          <div className={style.container}>
            {order?.payment?.status === PAYMENT_STATUS.EXPIRED
              ? renderHeader(
                  I18n.t("pages.orders.show.payment_expired"),
                  I18n.t("pages.orders.show.payment_expired_desc")
                )
              : renderHeader(
                  I18n.t("pages.orders.show.payment_failed"),
                  I18n.t("pages.orders.show.payment_failed_desc")
                )}
            <FailedPaymentCard />
            <RecapSection order={order} />
            <Actions order={order}/>
          </div>
        )
      } else {
        return (
          <div className={style.container}>
            {renderHeader(
              I18n.t("pages.orders.show.order_refused"),
              isRejectedByCustomer ? I18n.t("pages.orders.show.order_refused_by_customer_description") : I18n.t("pages.orders.show.order_refused_description")
            )}
            {!isRejectedByCustomer && <CancelledCard />}
            <RecapSection order={order} />
            <Actions order={order}/>
          </div>
        )
      }
    case ORDER_STATUS.PENDING_PAYMENT:
      return (
        <div className={style.container}>
          {renderHeader(
            I18n.t("pages.orders.show.pending_payment"),
            I18n.t("pages.orders.show.pending_payment_desc")
          )}
          <PendingPaymentCard expiresAt={order?.payment?.expires_at} />
          <RecapSection order={order} />
          <Actions order={order}/>
        </div>
      )
    case ORDER_STATUS.PAYMENT_FAILED:
      return (
        <div className={style.container}>
          {renderHeader(
            I18n.t("pages.orders.show.payment_failed"),
            I18n.t("pages.orders.show.payment_failed_desc")
          )}
          <FailedPaymentCard />
          <RecapSection order={order} />
          <Actions order={order}/>
        </div>
      )
    case ORDER_STATUS.ACCEPTED:
      return (
        <div className={style.container}>
          {order.mode === MODE_TAKE_AWAY
            ? renderHeader(
                I18n.t("pages.orders.show.order_accepted"),
                I18n.t(
                  "pages.orders.show.order_accepted_venue_takeaway_description_html",
                  {
                    time: order.start_time,
                    venue_name: order.venue?.name,
                    venue_address: `${order.venue?.address.street_name} ${order.venue?.address.street_number}`,
                  }
                ),
                true
              )
            : renderHeader(
                I18n.t("pages.orders.show.order_accepted"),
                I18n.t("pages.orders.show.order_accepted_description_html", {
                  name: order.racer?.first_name,
                  phone: order.racer?.phone_number || "--",
                }),
                true
              )}
          {renderGameCard()}
          <RecapSection order={order} />
          <Actions order={order}/>
        </div>
      )
    case ORDER_STATUS.PROCESSING:
      return (
        <div className={style.container}>
          {renderHeader(
            I18n.t("pages.orders.show.order_request_received"),
            I18n.t("pages.orders.show.order_accepted_description_html", {
              name: order.racer?.first_name,
              phone: order.racer?.phone_number || "--",
            }),
            true
          )}
          {/*order.mode !== MODE_TAKE_AWAY && renderCovidAlert()*/}
          {order.needs_phone_verification &&
            renderWarningCard(
              I18n.t("pages.orders.show.keep_your_phone_close"),
              "yellow"
            )}
          {renderGameCard()}
          {/* {order.credit_card &&
            order.payment.status === PAYMENT_STATUS.PREAUTHORIZED &&
            renderWarningCard(
              I18n.t("pages.orders.show.stripe.preauthorized_payment"),
              "blue"
            )}
          {order.credit_card &&
            order.payment.status === PAYMENT_STATUS.PAID &&
            renderWarningCard(
              I18n.t("pages.orders.show.stripe.paid_payment", {
                price: ((order?.payment?.paid_amount_cents || 0) / 100).toFixed(2),
              }),
              "blue"
            )} */}
          <RecapSection order={order} />
          <Actions order={order}/>
        </div>
      )
    default:
      // BRAND_NEW
      return (
        <div className={style.container}>
          {order.mode === MODE_TAKE_AWAY
            ? renderHeader(
                I18n.t("pages.orders.show.order_request_takeaway"),
                I18n.t("pages.orders.show.order_request_takeaway_warning")
              )
            : renderDeliveryHeader(order.date)}
          {/*order.mode !== MODE_TAKE_AWAY && renderCovidAlert()*/}
          {order.needs_phone_verification &&
            renderWarningCard(
              I18n.t("pages.orders.show.keep_your_phone_close"),
              "yellow"
            )}

          {renderGameCard()}
          {/* {order.credit_card &&
            order.payment.status === PAYMENT_STATUS.PREAUTHORIZED &&
            renderWarningCard(
              I18n.t("pages.orders.show.stripe.preauthorized_payment"),
              "blue"
            )}
          {order.credit_card &&
            order.payment.status === PAYMENT_STATUS.PAID &&
            renderWarningCard(
              I18n.t("pages.orders.show.stripe.paid_payment", {
                price: ((order?.payment?.paid_amount_cents || 0) / 100).toFixed(2),
              }),
              "blue"
            )} */}
          <RecapSection order={order} />
          <Actions order={order}/>
        </div>
      )
  }
}

// ----------------------------------------------------------------------------

export default OrderRecap
